import { Fragment } from "react";

import AppStoreButton, { StoreEnum } from "@/components/app-store-button";
import WrapperModal, {
  type WrapperModalProps,
} from "@/components/auth-modal/wrapper-modal";
import { Separator } from "@/components/ui/separator";

import type { MenuItemGroupType } from "./menu-items";

interface MobileMenuProps extends WrapperModalProps {
  items: MenuItemGroupType[];
}

export default function MobileMenu({ items, ...props }: MobileMenuProps) {
  const handleClose = () => props.onOpenChange?.(false);

  const storeButtonClassName =
    "aspect-[154/48] border border-black flex-1 h-12 rounded-[8px] w-full";
  const storeIconClassName = "h-[31px] w-auto";

  return (
    <WrapperModal bodyClassName="py-2.5 px-3.5" {...props}>
      <nav>
        {items.map((group, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: no change, fine
          <Fragment key={index}>
            <ul className="flex flex-col items-stretch gap-2.5">
              {(Array.isArray(group) ? group : group.items).map(
                ({ content, key }) => (
                  // biome-ignore lint/a11y/useKeyWithClickEvents: its fine
                  // biome-ignore lint/a11y/noNoninteractiveElementInteractions: its fine
                  <li key={key} onClick={handleClose}>
                    {content}
                  </li>
                )
              )}
            </ul>
            <Separator className="my-2.5 bg-white/10 last:hidden" />
          </Fragment>
        ))}
      </nav>
      <ul className="mt-2.5 grid standalone:hidden grid-cols-2 gap-5">
        <AppStoreButton
          className={storeButtonClassName}
          iconClassName={storeIconClassName}
          onClick={handleClose}
          store={StoreEnum.APPLE}
        />
        <AppStoreButton
          className={storeButtonClassName}
          iconClassName={storeIconClassName}
          onClick={handleClose}
          store={StoreEnum.GOOGLE}
        />
      </ul>
    </WrapperModal>
  );
}
